import { createContext, useContext } from 'react'

// Context for additive search providers (e.g. help articles, product navigation).
// These providers run alongside the primary provider and contribute supplementary
// results that are displayed in separate UI slots, not replacing the main results.

const defaultValue = {
  // Array of result blocks, one per registered additive provider.
  //
  // Shape: Array<{
  //   providerId:   string,
  //   hits:         any[],          // flat hits across the provider's domain
  //   indexResults: Object | undefined,
  //                                 // when set, mirrors AlgoliaSearchProvider's
  //                                 // per-index shape:
  //                                 //   { repos:          { hits, nbHits, hasMore, loadMore },
  //                                 //     folders:        { hits, nbHits, hasMore, loadMore },
  //                                 //     sets_questions: { hits, nbHits, hasMore, loadMore } }
  //                                 // Only providers that emit per-index data
  //                                 // populate this (currently `local-content`).
  // }>
  additiveResults: [],
}

export const SupplementarySearchContext = createContext(defaultValue)

export function useSupplementarySearch() {
  return useContext(SupplementarySearchContext)
}
